module.exports = __webpack_public_path__ + "static/media/Декларация_ОК_Й. Раденков.6bd37bbc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2020/Декларация_ОК_Й. Раденков.pdf
// module id = 121
// module chunks = 0